/**
 * Build a human-friendly filename (without extension) for a downloaded call/voice recording,
 * e.g. "Danilo Petrovic 2024-01-01". Falls back to a generic base when the contact name is
 * missing, and strips characters that are illegal in filenames. The extension is added by
 * MusicPlayer based on the source URL / blob type.
 *
 * The date is formatted from the local timezone parts so it matches how the surrounding history
 * UI displays the interaction date.
 */
export function buildRecordingDownloadName(contactName: string | undefined | null, date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  const datePart = `${year}-${month}-${day}`;

  const name = contactName?.trim();
  const base = name ? `${name} ${datePart}` : `Recording ${datePart}`;

  // Replace filesystem-illegal characters (\ / : * ? " < > |) with a space, then collapse runs of
  // whitespace. Hyphens (in the date) and normal spaces are preserved.
  return base.replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim();
}
